module.exports = __webpack_public_path__ + "static/Escalation_hires-1e8273a5efbc918da77fa89edf65f743.jpg";